import React from 'react';
import { Box } from '@mui/material';

const DotPulseLoading: React.FC = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '60px',
        }}
      >
        <Box
          sx={{
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            backgroundImage: 'linear-gradient(135deg, #ff6b6b, #f06595)',
            animation: 'pulse 1.2s infinite ease-in-out',
            animationDelay: '0s',
          }}
        />
        <Box
          sx={{
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            backgroundImage: 'linear-gradient(135deg, #6bc1ff, #6a95f0)',
            animation: 'pulse 1.2s infinite ease-in-out',
            animationDelay: '0.2s',
          }}
        />
        <Box
          sx={{
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            backgroundImage: 'linear-gradient(135deg, #6bffb6, #65f0a5)',
            animation: 'pulse 1.2s infinite ease-in-out',
            animationDelay: '0.4s',
          }}
        />
      </Box>
      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              transform: scale(1);
              opacity: 1;
            }
            50% {
              transform: scale(0.6);
              opacity: 0.6;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default DotPulseLoading;
